import React, { forwardRef } from 'react';
import './KSButton.scss';
import classNames from 'classnames';

export type KSButtonProps = {
  /** The label of the button */
  label: React.ReactNode;
  /** The color of the button */
  color?: 'primary' | 'secondary' | 'tertiary' | 'active' | 'open' | 'closed' | 'inProgress';
  /** type */
  type?: 'button' | 'submit' | 'reset';
  /** The size of the button */
  size?: 'small' | 'medium' | 'large';
  /** The variant of the button */
  variant?: 'contained' | 'outlined' | 'text';
  /** The text alignment of the button */
  textAlign?: 'left' | 'center' | 'right';
  /** The border radius of the button */
  rounded?: 'small' | 'medium' | 'large';
  /** The tag behavior of the button */
  tag?: 'allcaps' | 'title';
  /** The height behavior of the button */
  fullHeight?: boolean;
  /** The onClick event of the button */
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  className?: string;
  tooltip?: string;
};

const KSButton = forwardRef<HTMLButtonElement, KSButtonProps>(
  (
    {
      label,
      color = 'primary',
      size = 'small',
      variant = 'contained',
      rounded = 'medium',
      tag = 'allcaps',
      textAlign,
      fullHeight = false,
      onClick,
      type,
      disabled = false,
      icon = null,
      className: customClass = '',
      tooltip = '',
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        title={tooltip}
        className={classNames('ks-button', {
          [color]: true,
          [size]: true,
          [variant]: true,
          [`rounded-${rounded}`]: rounded,
          [`text-${textAlign}`]: textAlign,
          'full-height': fullHeight,
          [customClass]: customClass,
        })}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        <div className={classNames('ks-label', { [tag]: true })}>
          {label}
          <span>{icon}</span>
        </div>
      </button>
    );
  }
);

KSButton.displayName = 'KSButton';

export default KSButton;
